import React from 'react';
import { Link } from 'react-router-dom';
import { Play, Clock, CheckCircle } from 'lucide-react';
import { formatDuration, truncateText } from '../../lib/utils';

export const WebinarCard = ({ webinar }) => {
  const {
    webinar_id,
    title,
    description,
    duration_minutes,
    category,
    thumbnail_url,
    has_quiz,
  } = webinar;

  const defaultThumbnail = "https://images.unsplash.com/photo-1758272421243-3213b95006e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwzfHx3ZWJpbmFyJTIwcHJlc2VudGF0aW9uJTIwb25saW5lfGVufDB8fHx8MTc3NDQ0ODY1Mnww&ixlib=rb-4.1.0&q=85";

  return (
    <Link 
      to={`/masterclasses/${webinar_id}`}
      className="group relative bg-navigate-surface border border-zinc-800 rounded-xl overflow-hidden hover:border-navigate-gold/50 transition-all duration-300 hover:-translate-y-1 block"
      data-testid={`masterclass-card-${webinar_id}`}
    >
      {/* Image */}
      <div className="aspect-video w-full overflow-hidden bg-zinc-800 relative">
        <img 
          src={thumbnail_url || defaultThumbnail}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <div className="w-14 h-14 rounded-full bg-navigate-gold flex items-center justify-center">
            <Play className="h-6 w-6 text-black fill-black ml-1" />
          </div>
        </div>
        
        {/* Duration Badge */}
        <div className="absolute bottom-3 right-3 duration-badge px-2 py-1 rounded text-xs font-medium text-white flex items-center gap-1">
          <Clock className="h-3 w-3" />
          {formatDuration(duration_minutes)}
        </div>

        {/* Has Quiz Badge */}
        {has_quiz && (
          <div className="absolute top-3 right-3 bg-green-500/90 text-white px-2 py-1 rounded text-xs font-medium flex items-center gap-1">
            <CheckCircle className="h-3 w-3" />
            Quiz
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-4">
        {/* Category */}
        <div className="flex items-center gap-2 mb-2">
          <span className="tag text-xs">{category}</span>
          {has_quiz && webinar.quiz_id && (
            <span className="text-xs text-green-400 flex items-center gap-1">
              <CheckCircle className="h-3 w-3" />
              Quiz
            </span>
          )}
        </div>

        {/* Title */}
        <h3 className="font-heading font-semibold text-white text-base mb-2 group-hover:text-navigate-gold transition-colors line-clamp-2">
          {title}
        </h3>

        {/* Description */}
        <p className="text-xs text-zinc-400 line-clamp-2">
          {truncateText(description, 80)}
        </p>
      </div>
    </Link>
  );
};

export default WebinarCard;
